export default {
  pageTitle: "FOIRE AUX QUESTIONS",
  menu: {
    menu1: 'Compagnie et services',
    menu2: 'Comprendre le produit et le déguster',
    menu3: 'Commandes et livraisons',
    menu4: 'La politique des prix',
  },
  services: {
    title: 'Compagnie et services',
    tabList: {
      boires: 'Boires',
      ressourcesHumaines: 'Ressources humaines',
      producteurs: 'Producteurs',
      services: 'Services',
    },
    boires: [
      {
        question: 'Que veut dire Boires?',
        answer: 'BOIRES [bwaʁ] n.m. : Slang, néologisme, nom commun inspiré du mot anglais drinks. Dans notre jargon populaire, on l’utilise pour désigner des boissons désaltérantes, notamment les vins de notre agence.'
      },
      {
        question: 'Qu’est-ce qu’une agence de représentation?',
        answer: ''
      },
      {
        question: 'Quelle est la philosophie de l\'agence?',
        answer: ''
      },
      {
        question: 'Comment je fais pour contacter un représentant?',
        answer: 'La meilleure façon de nous contacter est via courriel à <a href="mailto:info@boires.ca">info@boires.ca</a> en mentionnant vos informations: </br>Nom et Prénom: </br>Adresse mail: </br>Numéro de téléphone:</br>Adresse Civique:'
      },
      {
        question: 'J\'ai une demande particulière, qui puis-je contacter?',
        answer: 'La meilleure façon d\'avoir rapidement réponse à vos questions est en écrivant un courriel à <a href="mailto:info@boires.ca">info@boires.ca</a> en mentionnant vos informations:</br> Nom et Prénom: </br>Adresse mail: </br>Numéro de téléphone:</br>Adresse Civique:'
      }
    ],
    ressources: [
      {
        question: 'J\'aimerais faire partie de l\'équipe de Boires',
        answer: 'Super! Envoie ton CV et une lettre de présentation à <a href="mailto:info@boires.ca">info@boires.ca</a>'
      },
    ],
    producteurs: [
      {
        question: 'Comment choisissez-vous vos producteurs?',
        answer: ''
      },
    ],
    services: [
      {
        question: 'Qu\'est-ce que l\'importation privée?',
        answer: 'L’importation privée ou IP c\'est la façon de commander des produits alcoolisés qui ne sont pas disponibles à la SAQ. Que tu sois restaurateur, une entreprise ou un client particulier tu peux facilement te procurer ces boires d\'exception par le biais de notre agence. Les produits en IP sont vendus à la caisse et le nombre de bouteilles par caisse varie selon le produit. Cette information est indiquée sur nos listes ou directement sur la page web des différents produits.'
      },
      {
        question: 'Est-ce que ma carte SAQ Inspire fonctionne chez vous?',
        answer: 'La carte inspire fonctionne seulement sur les produits vendus en SAQ, elle ne s\'applique pas sur les produits vendus via l\'importation privée.'
      },
      {
        question: 'Est-ce que je peux déguster à la boutique?',
        answer: 'Nous organisons des dégustations sur rendez-vous. Pour toutes questions écris à <a href="mailto:info@boires.ca">info@boires.ca</a>'
      },
      {
        question: 'Vendez-vous des boissons sans alcool ?',
        answer: ''
      },
      {
        question: 'Quelle est la différence entre un abonnement et être membre?',
        answer: ''
      },
      {
        question: 'Quelle est la différence entre l\'agence et la boutique?',
        answer: ''
      },
      {
        question: 'Avez-vous des coffrets cadeaux?',
        answer: ''
      },
      {
        question: 'Avez-vous des cartes cadeaux?',
        answer: ''
      },
    ],
  },
  understandProduct: {
    title: 'Comprendre le produit et le déguster',
    tabList: {
      tasteWine: 'Comment déguster le vin',
      jargon: 'Jargon',
    },
    tasteWine: [
      {
        question: 'Comment savoir si mon vin est bouchonné?',
        answer: 'Si tu sens une désagréable odeur de carton mouillé, poussière, champignon qui s\'accentue avec l\'aération, il n\'y a pas de doute, ton vin est bouchonné.'
      },
      {
        question: 'Pourquoi mon vin sent la ferme? ',
        answer: 'L\'odeur de ferme est habituellement associée à la réduction. C\'est naturel et ça devrait partir avec un bon carafage.'
      },
      {
        question: 'Quelle est la différence entre un vin oxydé et un vin oxydatif? ',
        answer: 'Un vin oxydatif est un vin élevé délibérément au contact de l\'air qui le protège de l\'oxydation et qui lui offre habituellement des arômes typiques tels la noisette, la pomme cuite et même les fruits séchés. Un vin oxydé est un vin à défaut. On le reconnait habituellement à ses arômes d\'arachides, d\'huile ou beurre rance qui a tendance à masquer tout fruit. Il peut également y avoir une altération de la couleur qui tire plus vers l\'orangé, peu importe la couleur originale du vin.'
      },
      {
        question: 'Mon vin pétille, c\'est normal? ',
        answer: 'Parfois le vigneron décide de laisser du CO2 afin de protéger le vin en réduisant la dose de soufre. Ce perlant s\'efface habituellement après un carafage. Il se peut qu\'un vin tranquille pétille autant qu\'un vin mousseux. Dans ce cas, cela signifie que la fermentation a repris dans votre bouteille parce qu\'il restait du sucre dans le vin à l\'embouteillage. Pas de panique, le vin reste très bon à la consommation. '
      },
      {
        question: 'Mon vin a des dépôts, c\'est normal? ',
        answer: 'Bien sur! Certaines cuvées ont un réel intérêt à vieillir en cave. Le plus important est de respecter certaines conditions qui sont : une température stable et inférieure à 15°C, un taux d\'humidité supérieur à 60%, pas de vibrations, de l\'obscurité et une pièce sans odeurs fortes.'
      },
      {
        question: 'Est-ce que je peux faire de la garde avec un vin naturel?',
        answer: 'Il peut y avoir un dépôt naturel qui n\'enlève aucune qualité ou goût au vin. Si tu préfères les vins clairs et transparents, manipule délicatement ta bouteille, les dépôts devraient rester au fond.  '
      },
      {
        question: 'Mon vin a gelé, est-il encore bon?',
        answer: 'Ton vin est toujours buvable et sans danger, mais un précipité tartrique va probablement se créer (petits cristaux transparents). Le vin pourrait avoir perdu de l\'acidité et son vieillissement sera compromis. Attention au verre brisé!',
      },
      {
        question: 'J\'ai laissé mon vin à la chaleur, est-il encore bon?',
        answer: 'Sous l\'effet de la chaleur, le vin risque d\'avoir une coulure sur le goulot. Il pourrait alors s\'oxyder. Il sera donc conseillé de le boire au plus vite si ce n\'est pas déjà trop tard. '
      },
      {
        question: 'J\'ai un très vieux vin, comment puis-je l\'ouvrir sans endommager le bouchon?',
        answer: 'Le meilleur moyen est l\'utilisation d\'un tire-bouchon de type bilame qui te permettra de retirer le bouchon en longeant les parois du goulot sans détériorer le liège plus fragile avec l\'âge.'
      },
      {
        question: 'Quelle est la température idéale pour garder mon vin?',
        answer: 'Il est préférable d\'utiliser un verre à pied, en verre ou cristal, avec un buvant relativement fin. Le calice (le contenant) se doit d\'être évasé pour permettre une aération raisonnable mais pas non plus excessive. Plusieurs types de verres sont possibles tous en fonction du vin que vous buvez. Mais peu importe le verre, un vin est toujours meilleur en bonne compagnie.  '
      },
      {
        question: 'Dois-je carafer ma bouteille?',
        answer: 'Certains vins blancs, rouges, rosés et même effervescents méritent le passage en carafe pour développer leurs arômes. D\'autres ne doivent surtout pas l\'être au risque d\'altérer leurs qualités. Le mieux est de demander à ton conseiller Boires.'
      },
      {
        question: 'Pourquoi mon vin est-il trouble?',
        answer: 'Cela signifie habituellement que le vin n\'a pas été filtré ou collé. Cela n\'enlève aucune qualité olfactive ou gustative, et permet même à ton vin d\'être plus résistant dans le temps.'
      },

    ],
    jargon: [
      {
        question: 'Agriculture raisonnée',
        answer: 'Démarche culturale conventionnelle dans laquelle le producteur tentent de diminuer l\'utilisation de produits de sythèse. Certains se cachent derrière ce therme et traitent leurs vignes de façon systémiques, alors que d\'autres ont une démarche sincère et font d’intenses efforts pour limiter l’utilisation des produits transformés.'
      },
      {
        question: 'Cahier de charge',
        answer: 'Un cahier de charge est un ensemble de règles auquel un producteur doit se soumettre dans le cas d\'une appélation controlée (zone géographique, type de cépage, vinifications particulière, temps d\'élevage et plus encore) ou d\'une certification (biologique, biodynamique, etc.)'
      },
      {
        question: 'Collage',
        answer: 'Le collage est une technique de vinification qui a pour objectif la clarification des vins. On introduit dans les jus fermentés, une substance protéique (blanc d\'oeuf, albumine de poisson, sang de bœuf, etc) qui va se précipiter vers le fond de la cuve et entrainer avec elle les molécules responsables de l\'aspect trouble des vins.'
      },
      {
        question: ' Du grain à la bouteille ',
        answer: 'Expression qui sert à qualifier des spiritueux élaborés à partir du grain, non pas à partir d’un alcool neutre acheté comme matière première à une distillerie industrielle. Selon ce standard, la distillerie artisanale doit transformer le grain elle-même pour obtenir l’alcool qui sera embouteillé.'
      },
      {
        question: 'Eau-de-vie',
        answer: 'Alors que le vin résulte d\'un processus de fermentation, l\'eau-de-vie est obtenu par fermentation, macération et distillation de fruits, de céréales, voir même de vin.'
      },
      {
        question: 'Élevage',
        answer: 'L\'élevage est le processus qui va permettre au vin de passer d\'un stade brut, juste après la fermentation alcoolique, à celui où il devient agréable à boire. Le vigneron suivant sa personnalité et/ou sa culture et son cahier de charge, peut choisir d\'élever ses vins dans différent contenant (barrique, cuve inox ou béton, amphore...) '
      },
      {
        question: 'Fermentation',
        answer: 'La fermentation est le biochimique par lequel des sucres sont transformés en alcool grace aux levures (quelles soient indigènes ou sélectionnées)'
      },
      {
        question: 'Filtration',
        answer: 'La filtration est une technique de vinification qui a pour objectif d\'éliminer les particules solides dans le vin. Elle sert à rendre le vin clair et limpide et à éliminer les bactéries potentiellement actives, afin de stabiliser les vins. On fait traverser les jus fermentés à travers un média filtrant qui capture la majorité des particules.'
      },
      {
        question: 'Levures indigènes',
        answer: 'Les levures, de micro-organismes présents naturellement sur le raisin et dans les caves des producteurs sont essentiels à la fermentation. Pour les vignerons travaillant de façon authentique, elles sont les seules garantes de la typicité du terroir.'
      },
      {
        question: 'Levures sélectionnées',
        answer: 'L\'utilisation excessive produite chimique dans la vigne tend à diminuer la population de levures indigènes naturellement présentes sur les raisins. Pour assurer que les fermentations partent, les producteurs de vins conventionnels doivent utiliser des levures chimiques (ou sélectionnées)  afin d’assurer la fermentation de leurs vins. Une panoplie de levures sélectionnées est disponible sur le marché. Elles sont facilement reconnaissables par leurs arômes distinctifs.'
      },
      {
        question: 'Méthode traditionnelle',
        answer: 'La méthode traditionnelle est une méthode d\'élaboration de vins effervescents qui consiste en une seconde fermentation en bouteilles d\'un vin tranquille après ajout d\'une liqueur de tirage. La méthode traditionnelle d\'élaboration d\'un vin effervescent est identique à la méthode champenoise pour l\'élaboration du champagne.'
      },
      {
        question: 'Micro-brasserie ',
        answer: 'Bien qu’il n’y ait pas de définition formelle de ce terme, il est utilisé pour décrire une nouvelle génération de petites brasseries spécialisées dans la production de bières, non filtrée et non pasteurisée'
      },
      {
        question: 'Microdistillerie',
        answer: 'Une microdistillerie ou distillerie artisanale est un lieu de fabrication, en quantité limitée, de spiritueux obtenu par distillation. '
      },
      {
        question: 'Permaculture',
        answer: 'La parmaculture vise à développer des systèmes agricoles, basés sur la diversité des cultures, leur résilience et leur productivité naturelle. En laissant de la place à d’autres espèces de plantes et arbres, des ruches, ou des animaux, pour désherber, manger certains insectes nuisibles et produire de l\'engrais naturel.'
      },
      {
        question: 'Pet nat',
        answer: 'Un pétillant naturel, Pet Nat ou méthode ancestrale, est un vin qui été mis en bouteille avant la fin de sa fermentation. Le gaz carbonique produit par la fermentation qui continue dans la bouteille, va être piégé et absorbé par le vin sous forme de bulles.'
      },
      {
        question: 'Réduction',
        answer: 'Ton vin a des arômes d\'oeuf pourri ou de chou ? Il ne s\'agit ici que de réduction. Un peu d\'air dans une carafe et le tour est joué.'
      },
      {
        question: 'Soufre',
        answer: 'Qu\'il soit d\'origine volcanique ou dérivé du pétrole (anhydryde sulfureux), le soufre est utilisé dans le vin pour deux raisons. Il agit en tant qu’antioxydant et en tant qu’antibiotique, en pour stabilisant et stoppant la prolifération bactérienne dans les vins. Il est utilisé dans d\'autres produits alimentaires, tels que les fruits secs qui en contiennent des quantités souvent bien supérieures à celle que l\'on retrouve dans le vin. '
      },
      {
        question: 'Terroir',
        answer: 'Bien souvent, le terroir est perçu comme étant seulement le sol dont sont issus les vins. Dans un sens plus large, le terroir se compose du sol, du cépage cultivé, de la climatologie propre à la région ainsi que des pratiques culturales de la femme ou de l\'homme qui le cultive.'
      },

      {
        question: 'Vin Biologique',
        answer: 'Vin élaboré à partir de raisins issus d\'une viticulture certifiée biologique (sans pesticide, ni herbicide et suivant le cahier de charge de la société de certification). L\'utilisation d\'intrants lors de la vinification est limitée.'
      },
      {
        question: 'Vin Biodynamique ',
        answer: 'Viticulture holistique qui a pour objectif de renforcer la vitalité et la résistance de la plante par l\'application de traitements homéopathiques préventifs, sous un calendrier lunaire précis. C’est plus compliqué que ça, pour plus d’info :  <a href="https://www.demeter.fr/biodynamie/">https://www.demeter.fr/biodynamie/</a>'
      },
      {
        question: 'Vin conventionnel - contemporain - chimique',
        answer: 'Vins issus d\'une viticulture automatisée et faisant usage d\'engrais chimiques et de produits phytosanitaires (herbicides, pesticides, etc). La vinification repose sur des intrants œnologiques de synthèse (acidification, sucre, levures sélectionnées, etc.) afin d’avoir un produit toujours égal et contrôlé. '
      },
      {
        question: 'Vin glouglou',
        answer: 'Un vin à boire sans soif, à tout moment de la journée. Du fruit en bouteille à se partager entre amis jusqu\'au petites heures du matin.'
      },
      {
        question: 'Vin nature ou naturel ',
        answer: 'Haaaaa la grande question! Il n\'y a pas de cahier de charge officiel sur ce qu\'est un vin naturel, mais voici notre opinion : Les raisins sont nécessairement issus d\'une viticulture biologique ou biodynamique, certifiée ou non. Aucun manipulation technologique n\'est autorisée en vinication, mis à part d\'infimes dose de soufre'
      },

      {
        question: 'Vin orange',
        answer: 'Un vin orange est un vin blanc de macération. Comme pour un vin rouge, on laisse les jus macérer au contact des peaux du raisin. Les peaux donnent au vin une couleur plus ou moins orangée selon leurs pigments originels et offrent des tanins plus ou moins importants selon le cépage et le temps de macération. '
      },

      {
        question: 'Vin oxydatif',
        answer: 'Ce dit d\'un vin qui a été volontairement oxygéné durant la vinification, modifiant ainsi ses arômes (pommes très mûres, épices, noisette et noix). Les plus connus sont les Vins Jaunes du Jura et les Xérès espagnols.'
      },
      {
        question: 'Vin propre',
        answer: 'Démarche culturale conventionnelle dans laquelle le producteur tentent de diminuer l\'utilisation de produits de sythèse. Certains se cachent derrière ce therme et traitent leurs vignes de façon systémiques, alors que d\'autres ont une démarche sincère et font d’intenses efforts pour limiter l’utilisation des produits transformés.'
      },
      {
        question: 'Volatile',
        answer: 'L\'acide volatile, qui regroupe l\'acétate d\'éthyle (arôme de vernis à ongle) et l\'acide acétique (vinaigre) est présente dans tous les vins à hauteur d\'au moins 0,2g/l. À dose modérée, elle apporte une fraicheur au vin, mais peut apporter des arômes vinaigrés quand trop haute.'
      },
    ],
  },
  ordersDeliveries: {
    title: 'Commandes et livraisons',
    tabList: {
      commander: 'Commander',
      problems: 'Problèmes avec une commande',
      livraison: 'Livraison',
    },
    tagLine: 'Pour tout autre problème, contactez-nous! <br>Problème avec une commande',
    commander: [
      {
        question: 'Pourquoi dois-je acheter à la caisse?',
        answer: 'Selon la loi régie par la SAQ, les produits vendus via l\'Importation Privée sont seulement disponibles à la caisse.'
      },
      {
        question: 'Est-ce que je peux commander une caisse mixte?',
        answer: ''
      },
      {
        question: 'Comment puis-je commander en importation privée?',
        answer: ''
      },
      {
        question: 'Comment faire le suivi de ma commande livrée en SAQ?',
        answer: 'Ta SAQ ne t’a toujours pas contacté après 10 jours ouvrables suivant le paiement des frais d’agences? Écris-nous à <a href="mailto:info@boires.ca">info@boires.ca</a>, nous allons t’arranger ça!'
      },
      {
        question: 'Le produit que je désire n\'est pas disponible, que faire?',
        answer: 'Clique sur la case Réserver sur la page internet du produit qui t\'intéresse. Lorsque le produit sera disponible, nous communiquerons avec toi et tu auras 5 jours pour acquitter les frais avant que le produit soit remis en inventaire. Il n\'y aura aucune confirmation de commande avant le paiement.'
      },
      {
        question: 'Est-ce que je peux réserver des produits à venir?',
        answer: 'Nous prenons les précommandes!  Lorsque le produit sera disponible, nous communiquerons avec toi et tu auras 5 jours pour acquitter les frais avant que le produit soit remis en inventaire.'
      },
      {
        question: 'Comment faire pour commander des produits disponibles à la SAQ?',
        answer: 'Va sur le site de la SAQ au <a href="www.saq.com">www.saq.com</a> et sélectionne le produit désiré. Tu y trouveras les succursales qui tiennent le produit et le nombre de bouteilles disponibles. Tu pourras également y voir quels produits sont disponibles pour la vente en ligne et en livraison.'
      },
      {
        question: 'Pourquoi dois-je acheter un aliment pour commander de l’alcool en boutique?',
        answer: 'Parce que c\'est la loi.<br>Pour plus d\'information, nous t\'invitons a lire l\'article suivant:<br><a href="http://legisquebec.gouv.qc.ca/fr/ShowDoc/cs/p-9.1#:~:text=Le%20permis%20de%20bar%20autorise,71%2C%20a"><b>P-9.1</b> - Loi sur les permis d’alcool</a>.'
      },
      {
        question: 'J\'ai des restrictions alimentaires',
        answer: ''
      }
    ],
    problems: [
      {
        question: 'Politique de retour Agence',
        answer: 'Assure-toi d\'avoir ta facture SAQ en main pour un retour de bouteilles défectueuses. La SAQ est responsable de ce service après-vente, aucun remboursement ne sera fait par Boires. À noter qu’il est impossible de retourner une bouteille pour une question de goût personnel. Nous t\'invitons à appeler le Centre de relation clientèle SAQ de Montréal : (514) 254-8686 poste 8048'
      },
      {
        question: 'Je n\'ai pas de nouvelle de ma succursale SAQ concernant ma commande',
        answer: 'Ta SAQ ne t’a toujours pas contacté après 10 jours ouvrables suivant le paiement des frais d’agences? Écris-nous à <a href="mailto:info@boires.ca">info@boires.ca</a>, nous allons t’arranger ça! '
      },
      {
        question: 'Politique de retour Boutique ',
        answer: 'Échange seulement'
      },
    ],
    livraison: [
      {
        question: 'Délais de livraison',
        answer: ''
      },
      {
        question: 'Est-ce que je peux faire livrer ma commande à domicile?',
        answer: ''
      },
      {
        question: 'Quels sont les frais de livraison?',
        answer: ''
      },
      {
        question: 'Politique concernant les bouteilles endommagées à la livraison (SAQ)',
        answer: ''
      },
      {
        question: 'Politique concernant les bouteilles endommagées à la livraison boutique',
        answer: ''
      },
    ],
  },
  pricingPolicy: {
    title: 'La politique des prix',
    tabList: {
      pricingPolicy: 'La politique des prix',
    },
    pricingPolicy: [
      {
        question: 'Comprendre la structure de prix et les frais d’agence',
        answer: 'Les prix affichés sur nos listes incluent le prix de base de la bouteille et les frais d’agence, mais excluent les taxes (TPS et TVQ) '
      },
      {
        question: 'Pourquoi y a-t-il une différence de prix entre les produits en boutiques et ceux à la caisse? ',
        answer: ''
      },
      {
        question: 'Qu\'est-ce qui est inclu dans le prix affiché? ',
        answer: 'Les prix affichés sur nos listes incluent le prix de base de la bouteille et les frais d’agence, mais excluent les taxes (TPS et TVQ) '
      },
    ],
  },

}
